module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ixXfI"))).then(() => parcelRequire('1iHdE'));